import {
	ComposeSentryErrorLogger,
	Environment,
	IErrorLoggerWithUserSupport,
} from '@verv-inc/js-toolkit';
import packageJson from '../../../package.json';

export const composeVervSentryErrorLogger = (): IErrorLoggerWithUserSupport => {
	const getSentryEnvironment = (): Environment => {
		if (process.env.REACT_APP_ENVIRONMENT === 'dev') {
			return Environment.dev;
		} else if (process.env.REACT_APP_ENVIRONMENT === 'test') {
			return Environment.test;
		}
		return Environment.prod;
	};

	return ComposeSentryErrorLogger({
		dsn: process.env.REACT_APP_SENTRY_KEY,
		environment: getSentryEnvironment(),
		releaseVersion: packageJson.version,
		httpClientOptions: {
			failedRequestStatusCodes: [400, 599],
			failedRequestTargets: [/api.*verv\./i],
		},
	});
};
